/* eslint-disable max-lines-per-function */
import React from "react";
import { useInterestsTable } from "./table-context";

const buttonStyle = {
  border: "none",
  background: "none",
  textDecoration: "underline",
};

const InterestSelectionPrompt: React.FC<{totalSelectionCount: number; selectedCount: number}> =
(props) => {
  const {
    tableResults,
    selectAllInterests,
    deselectAllInterests: handleDeselectAll,
    hasSelectedAllInterests,
    totalTableResults,
    selectedPageRange,
    fullPageOrAllPagesSelected,
  } = useInterestsTable();

  const handleSelectAll = () => {
    const visibleIds = tableResults.map(interest => interest.id);
    selectAllInterests(visibleIds);
  };

  const totalCount = () =>
    (hasSelectedAllInterests ? totalTableResults : props.selectedCount);


  const { from, to } = selectedPageRange;
  const isPageRangeSelected = from !== null || to !== null;

  if (!(fullPageOrAllPagesSelected || isPageRangeSelected)) return null;

  const selectAllButton = (
    <button onClick={handleSelectAll} style={buttonStyle}>
        Select all <b>{totalTableResults}</b> applications
    </button>
  );

  const deselectButton = (
    <button onClick={handleDeselectAll} style={buttonStyle}>
        Clear selection
    </button>
  );

  return (
    <div
      style={{
        backgroundColor: "#d0edf1",
        textAlign: "center",
        padding: "8px",
        margin: "8px 0 8px",
      }}
    >
      <span>
        {isPageRangeSelected ? (
          `Selected applicants on pages ${from === null ? "" : `${from + 1}`} ${to === null ? "" : `to ${to + 1}`}: `) : <>
          All <b>{totalCount()}</b> applications&nbsp;
          {(hasSelectedAllInterests || isPageRangeSelected) ? "in this search " : "on this page "}
          are selected.
        </>}
      </span>
      {hasSelectedAllInterests ? deselectButton : selectAllButton}
    </div>
  );
};

export default InterestSelectionPrompt;
